import { render, staticRenderFns } from "./TeacherFeedback.vue?vue&type=template&id=6db79ae9&scoped=true"
import script from "./TeacherFeedback.vue?vue&type=script&lang=js"
export * from "./TeacherFeedback.vue?vue&type=script&lang=js"
import style0 from "./TeacherFeedback.vue?vue&type=style&index=0&id=6db79ae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db79ae9",
  null
  
)

export default component.exports